import { TeamMembersRequestType } from '__generated__/GQL';

export const requestTypeToKey = (
  requestType: TeamMembersRequestType,
): 'physicalCard' | 'virtualCard' | 'virtualBudgetCard' => {
  switch (requestType) {
    case TeamMembersRequestType.PhysicalPaymentCardOrder:
      return 'physicalCard';
    case TeamMembersRequestType.VirtualPaymentCardOrder:
      return 'virtualCard';
    case TeamMembersRequestType.VirtualBudgetCardOrder:
      return 'virtualBudgetCard';
    default:
      return 'virtualCard';
  }
};
